import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { readClubSession } from '@/lib/auth/session-store'
import { AppShell } from '@/components/shell/AppShell'

export const Route = createFileRoute('/_app')({
  beforeLoad: ({ location }) => {
    if (!readClubSession()) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      })
    }
  },
  component: AppLayout,
})

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  )
}
